import React from 'react';
import { Instagram, Youtube, Video } from 'lucide-react';
import { Button } from '../components/Button';
export function SocialsPage() {
  return <main className="flex-grow bg-black" data-id="element-261">
      {/* Hero */}
      <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-262">
        <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6" data-id="element-263">
          Follow My Journey
        </h1>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-264">
          Daily training tips, behind the scenes, and martial arts lifestyle
          content across Instagram, TikTok, and YouTube.
        </p>
      </section>

      {/* Content Grid */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-265">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-266">
          {/* Instagram Column */}
          <div className="space-y-6" data-id="element-267">
            <div className="flex items-center justify-center space-x-2 text-[#E1306C]" data-id="element-268">
              <Instagram size={24} data-id="element-269" />
              <h2 className="text-xl font-bold text-white" data-id="element-270">Instagram</h2>
            </div>
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden shadow-sm aspect-[9/16] flex items-center justify-center" data-id="element-271">
              <p className="text-gray-400" data-id="element-272">@aleks.szulc1</p>
            </div>
            <Button href="https://www.instagram.com/aleks.szulc1/" variant="outline" className="w-full" data-id="element-273">
              Follow on Instagram
            </Button>
          </div>

          {/* TikTok Column */}
          <div className="space-y-6" data-id="element-274">
            <div className="flex items-center justify-center space-x-2" data-id="element-275">
              <Video size={24} className="text-white" data-id="element-276" />
              <h2 className="text-xl font-bold text-white" data-id="element-277">TikTok</h2>
            </div>
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden shadow-sm aspect-[9/16] flex items-center justify-center" data-id="element-278">
              <p className="text-gray-400" data-id="element-279">@aleks.szulc1</p>
            </div>
            <Button href="https://www.tiktok.com/@aleks.szulc1" variant="outline" className="w-full" data-id="element-280">
              Follow on TikTok
            </Button>
          </div>

          {/* YouTube Column */}
          <div className="space-y-6" data-id="element-281">
            <div className="flex items-center justify-center space-x-2 text-[#FF0000]" data-id="element-282">
              <Youtube size={24} data-id="element-283" />
              <h2 className="text-xl font-bold text-white" data-id="element-284">YouTube</h2>
            </div>
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden shadow-sm aspect-[9/16] flex items-center justify-center" data-id="element-285">
              <p className="text-gray-400" data-id="element-286">@aleks.szulc1</p>
            </div>
            <Button href="https://youtube.com/@aleks.szulc1" variant="outline" className="w-full" data-id="element-287">
              Subscribe on YouTube
            </Button>
          </div>
        </div>
      </section>

      {/* Description Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black to-gray-900 border-t border-gray-800 mt-12" data-id="element-288">
        <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-289">
          <h2 className="text-2xl font-bold text-white" data-id="element-290">
            Why I Create Content
          </h2>
          <p className="text-gray-300 leading-relaxed" data-id="element-291">
            I started documenting my journey to show the reality of martial arts
            training—the highs, the lows, and everything in between. My goal is
            to inspire others to start their own journey and provide practical
            tips that I've learned along the way.
          </p>
          <p className="text-gray-300 leading-relaxed" data-id="element-292">
            Follow along for training insights, technique breakdowns, and a
            behind-the-scenes look at the life of a martial artist and coach.
          </p>
        </div>
      </section>
    </main>;
}